import BdsAlertTemplate from './templates/BdsAlertTemplate.html';
export class AlertService {
    constructor(ModalService) {
        this.ModalService = ModalService;
    }
    async show({ callback, variant, icon, title, body, buttons }) {
        /*  We create a local controller to set the callback actions.
            It will be useful when called on Processors to be shown on fragment projects.
        */
        // Inline controller with explicit $inject for minification safety
        const AlertController = function (close) {
            this.variant = variant;
            this.icon = icon;
            this.title = title;
            this.body = body;
            this.buttons = buttons;
            this.closeAlert = close;
            this.cancelButtonAction = () => { callback?.cancelButtonAction(); close(); };
            this.confirmButtonAction = () => { callback?.confirmButtonAction(); close(); };
        };
        AlertController.$inject = ['close'];
        const modal = await this.ModalService.showModal({
            template: BdsAlertTemplate,
            controller: AlertController,
            controllerAs: '$ctrl',
        });
        modal.element[0].setAttribute('open', true);
        return modal;
    }
    async closeAllAlerts() {
        await this.ModalService.closeModals();
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
AlertService.$inject = ['ModalService'];
